import { http } from '@/http'

/**
 * Servicio de preferencias de columnas por usuario (Keycloak sub, resuelto en backend).
 * Implementa la interfaz que espera draggableColumnsMixin (@wizepe/wizeui):
 *   - load(listKey)  → Promise<{ order: string[], hidden: string[] }>
 *   - save(listKey, { order, hidden }) → Promise
 *
 * Endpoints (baseURL ya incluye /api/v1):
 *   GET  /user-preferences/columns/{listKey}
 *   PUT  /user-preferences/columns/{listKey}
 *
 * El interceptor de http resuelve al body { status, payload }, así que load
 * desenvuelve `payload`. Ante cualquier fallo o respuesta inesperada, load cae a
 * un objeto vacío para no romper la inicialización de la tabla.
 */
const EMPTY = { order: [], hidden: [] }

export default {
  async load(listKey) {
    try {
      const res = await http.get(`/user-preferences/columns/${listKey}`)
      const payload = res && res.payload ? res.payload : res
      return {
        order: Array.isArray(payload && payload.order) ? payload.order : [],
        hidden: Array.isArray(payload && payload.hidden) ? payload.hidden : [],
      }
    } catch (e) {
      return { ...EMPTY }
    }
  },

  save(listKey, config) {
    const body = {
      order: Array.isArray(config && config.order) ? config.order : [],
      hidden: Array.isArray(config && config.hidden) ? config.hidden : [],
    }
    return http.put(`/user-preferences/columns/${listKey}`, body)
  },
}
